import './main.css';
import 'utils/panel';
import Layout from 'utils/layout';
import Video from 'utils/video';

(() => {
  if (window.__stellarMainInitialized) return;

  window.__stellarMainInitialized = true;

  const uniq = (value, index, self) => self.indexOf(value) === index;
  const sections = document.querySelectorAll('[data-section]');
  const sectionNames = [...sections]
    .map((section) => section.dataset.section)
    .filter(uniq)
    .filter((name) => name && !String(name).startsWith('template--'));
  const layout = Layout.getInstance();

  sectionNames.forEach((name) => {
    import(/* webpackChunkName: "[index]" */ `./${name}/index.js`)
      .then((m) => {
        const module = m.default;
        if (typeof module !== 'function') {
          // eslint-disable-next-line no-console
          console.error(`[section-loader] "${name}" default export is not a function:`, module);
          return;
        }
        const modules = [...sections].filter(
          (section) => section.dataset.section === name,
        );
        modules.forEach((element) => {
          const dataEl = element.querySelector('[data-section-data]');
          const data = dataEl ? JSON.parse(dataEl.textContent) : {};
          const videoEls = element.querySelectorAll('[data-component="video"]');
          const videos =
            videoEls &&
            [...videoEls].map(
              (videoEl) => new Video({ element, video: videoEl, layout }),
            );
          try {
            module(element, { ...data, layout, videos });
          } catch (err) {
            // eslint-disable-next-line no-console
            console.error(`[section-loader] "${name}" init threw:`, err);
          }
        });
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error(`[section-loader] "${name}" import failed:`, err);
      });
  });

  document.addEventListener('DOMContentLoaded', () => {
    document.addEventListener('keypress', (e) => {
      if (e.key === 'Enter') {
        if (e.target.classList.contains('dfd-searchbox-input')) {
          const seqrchQ = e.target.value;
          window.location.href = `${window.routes.search_url}?q=${encodeURI(seqrchQ)}&type=product`;
        }
      }
    });
  });

  class ProductCard extends HTMLElement {
    constructor() {
      super();
      this.hasVideo = this.querySelector('.secondary-product-card').classList.contains('has-video');
      if(this.hasVideo){
        this.addEventListener('mouseover', this.hoverVideo)
      }
    }
  
    hoverVideo() {
      this.video = this.querySelector('.product-card__secondary-video video')
      this.video.currentTime = 0;
      this.video.play()
    }
  }
  
  if (!customElements.get('product-card')) {
    customElements.define('product-card', ProductCard);
  }
})();
